import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '@deliveroo/consumer-component-library/components/Button';

import styles from './styles.scss';

/**
 * A row of buttons which will use the correct width per button type and combination.
 */
function ButtonGroup(props) {
  const buttons = React.Children.toArray(props.children).filter((component) => {
    const isButton = component.type === Button;
    if (!isButton) {
      // eslint-disable-next-line no-console
      console.warn(
        `The ButtonGroup component only accepts Button components as children. Omitting a component of type "${
          component.type.displayName
        }".`,
      );
    }
    return isButton;
  });

  const numberOfButtons = buttons.length;

  const wrapperClasses = classnames(styles.innerWrapper, {
    [styles.shouldStackOnMobile]: props.shouldStackOnMobile,
  });

  return (
    <div className={styles.wrapper}>
      <div className={wrapperClasses}>
        {buttons.map((button) => {
          const classes = classnames(styles.buttonWrapper, {
            [styles[button.props.type]]: numberOfButtons === 2,
          });
          return (
            <div className={classes} key={button.key}>
              {React.cloneElement(button, {
                isBlock: true,
                spacing: undefined,
                adjacentVerticalSpacing: undefined,
                adjacentHorizontalSpacing: undefined,
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}

ButtonGroup.propTypes = {
  /**
   * Will only render Button components and omit components of all other types.
   */
  children: PropTypes.node.isRequired,

  /**
   * Whether the buttons should vertically stack on mobile screen size or not.
   */
  shouldStackOnMobile: PropTypes.bool,
};

ButtonGroup.defaultProps = {
  shouldStackOnMobile: true,
};

export default ButtonGroup;
